import {
  Component,
  Directive,
  Input,
  OnInit,
  OnDestroy,
  HostBinding
}                       from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { LyTheme }      from 'alyle-ui/core';
import { CommonModule } from '@angular/common';

@Directive({
  selector: 'ly-toolbar-item',
})
export class ToolbarItem {}

@Component({
  selector: 'ly-toolbar',
  template: '<ng-content></ng-content>',
  styles: [":host[ly-dense] { height: 48px; line-height: 48px; } :host { background: 0 0; margin: 0; max-width: 100%; width: 100%; min-height: 48px; height: 64px; box-sizing: border-box; display: flex; align-items: center; position: relative; font-size: 20px; } ",
":host /deep/ ly-toolbar-item { font-weight: 400; vertical-align: middle; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; } :host /deep/ ly-toolbar-item[ly-toolbar-item-padding] { padding: 0 16px; } "],
})
export class LyToolbar implements OnInit, OnDestroy {
  /** Set default bg */
  private _bg = 'primary';

  /** set default color */
  private _color = 'main';

  private _subscription: Subscription;
  @HostBinding('style.background') styleBackground: string;
  @HostBinding('style.color') styleColor: string;

  constructor(public theme: LyTheme) { }

  @Input()
  set toolbarBg(val: string) {
    this._bg = val;
  }

  @Input()
  set toolbarColor(val: string) {
    this._color = val;
  }

  ngOnInit() {
    this._subscription = this.theme.palette.subscribe((colors: any) => {
      this.styleBackground = this.theme.colorOf(this._bg);
      this.styleColor = this.theme.colorOf(this._color);
    });
  }

  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }
}

